<template>

  <m-pay-layout>

    <v-layout justify-center align-top class="mx-2">
      <v-flex grow>

        <m-pay-generic-paging-table
          :headers="headers"
          :queryFunctionName="queries.exchangeXmls.name"
          :csvQueryFunctionName="queries.exchangeXmlsCsv.name"
          :cellClasses="{ purchaseId: 'pl-3 pr-1', merchant: 'pl-0 pr-0' }"
        >
          <template slot-scope={item} slot="purchaseId">
            <router-link :to="{ name: 'purchase', params: { purchaseId: item.purchaseId } }">
              <v-tooltip bottom>
                <span slot="activator">
                  <v-icon color="secondary">shopping_cart</v-icon>
                </span>
                <span>Purchase</span>
              </v-tooltip>
            </router-link>
          </template>
          <template slot-scope={item} slot="merchant">
            <router-link :to="{ name: 'merchant', params: { merchantId: item.merchantId } }">
              <v-tooltip bottom>
                    <span slot="activator">
                      <v-icon color="secondary">store</v-icon>
                    </span>
                <span>Merchant</span>
              </v-tooltip>
            </router-link>
          </template>
          <template slot-scope={value} slot="xmlType">
            <m-pay-status :value-classes="exchangeXmlRequestTypeStatusClasses" :value="value"/>
          </template>
          <template slot-scope={value} slot="callbackStatus">
            <m-pay-status :value-classes="purchaseCallbackStatusClasses" :value="value"/>
          </template>
          <template slot-scope={value} slot="xml">
            <m-pay-copy-button :value="value"></m-pay-copy-button>
          </template>
        </m-pay-generic-paging-table>

      </v-flex>
    </v-layout>
  </m-pay-layout>

</template>

<script>
import MPayGenericPagingTable from './MPayGenericPagingTable';
import MPayStatus from './MPayStatus';
import MPayCopyButton from './MPayCopyButton';
import roles from '../utils/user-roles';
import { exchangeXmlRequestTypeStatusClasses, purchaseCallbackStatusClasses } from '../utils/statuses';

export default {
  name: 'MPayExchangeXmlsPage',

  components: { MPayGenericPagingTable, MPayStatus, MPayCopyButton },

  data: () => ({
    headers: [
      { text: '', value: 'purchaseId', sortable: false, filterable: false },
      { text: '', value: 'merchant', sortable: false, filterable: false, role: roles.READ_ANY_PURCHASE },
      { text: 'Created Date', value: 'createdDate', width: 155 },
      { text: 'Request Type', value: 'xmlType' },
      { text: 'Payload', value: 'xml', align: 'center', filterable: false },
    ],
    purchaseCallbackStatusClasses,
    exchangeXmlRequestTypeStatusClasses,
  }),
};
</script>



// WEBPACK FOOTER //
// src/components/MPayExchangeXmlsPage.vue